import { CSSProperties } from "react";
import FontWeight from "../../../../../models/constants/FontWeight";

export default class WorkerInfoViewStyle {

    form : CSSProperties = {
        display : 'flex',
        flexDirection : 'column',
        flex : 1,
        justifyContent : 'space-between',
        marginTop:20 
    }

    row : CSSProperties = {
        display : 'flex',
        justifyContent : 'space-between'
    }

    inputMargin : CSSProperties = {
        marginRight : 15
    }

    label : CSSProperties = {
        fontFamily : 'Roboto',
        fontWeight : FontWeight.LIGHT,
        fontSize : 13,
        color : '#9F9F9F'
    }

    addressInput : CSSProperties = {
        width : '100%',
        fontWeight : FontWeight.LIGHT
    }
}